<template>
  <div id="app" class="flex flex-col min-h-screen bg-slate-50 text-slate-900 font-sans">
    <router-view />
    <WhatsAppFloat />
  </div>
</template>

<script>
import WhatsAppFloat from '@/components/common/WhatsAppFloat.vue'

export default {
  name: 'App',
  components: {
    WhatsAppFloat
  },
  created() {
    this.$store.dispatch('settings/fetchSettings')
  }
}
</script>

<style>
html {
  scroll-behavior: smooth;
}
</style>
